// common
export const PERIOD_KEY = 'period';
export const MEASURE_KEY = 'measure';
export const FORM_UID_KEY = 'formUid';

// trc-spcecific
export const IS_COMPLETE_KEY = 'isComplete';
export const ACCESS_LINK_KEY = 'accessLink';
